import { AppLogo } from '../../../../components/SVGIcons/AppLogo/AppLogo';

import classes from './HeaderLeftElement.module.scss';

export const HeaderLeftElement = (props: { showLogo: boolean; onClick?: () => void }) => {
  return (
    <div className={classes.headerLeftElement} onClick={props.onClick}>
      {props.showLogo ? <AppLogo alwaysColorful /> : null}
    </div>
  );
};
